class Owl {
    constructor() {
        this.heroBanner();
        this.homeBillboard();
        this.matchCarousel(
            ".owl-carousel--billboard-item",
            ".owl-carousel--billboard"
        );
        this.homeProject();
        this.homeNews();
        this.assetInfo();
    }

    heroBanner() {


        var SLIDER_TIMEOUT = 5000;
        var animationStyle;
        var progressBar;
        var clonedProgressBar;
        var $progressBar;
        var $selector = $('.owl-carousel--billboard');


        $selector.owlCarousel({
            items: 1,
        loop: false,
        rewind: true,
        margin: 0,
        nav: false,
        dots: true,
        dotsContainer: ".banner-dots",
        mouseDrag: false,
        touchDrag: false,
        autoplay: true,
        autoplayHoverPause: false,
        smartSpeed: 1000,
        animateIn: "fadeIn",
        animateOut: "fadeOut",
        
            autoplayTimeout: SLIDER_TIMEOUT,
            
            onInitialized: initializedCarousel,
            onChange: activeCarouselComponents,
        });


        function addZero(number) {
            var rez = '' + number;
            while (rez.length < 2) {
                rez = '0' + rez;
            }
            return rez;
        }

        function initializedCarousel(e) {

            animationStyle = `-webkit-animation-duration:${SLIDER_TIMEOUT}ms;animation-duration:${SLIDER_TIMEOUT}ms`;
            progressBar = $(
                `<div class="owl-progress-bar"><div class="progress"><span class="progress__item" style="${animationStyle}"></span></div></div>`
            );
            $(e.target).append(progressBar);

            
            activeCarouselComponents(e);
        }


        function activeCarouselComponents(e) {

            $progressBar = $(e.target).find(".owl-progress-bar");
            clonedProgressBar = $progressBar.clone(true);

            $progressBar.remove();
            $(e.target).append(clonedProgressBar);



            let initItems = 1;
            let current = e.page.index + 2;
            let itemsCount = e.page.count;
            let itemsSize = e.page.size;

            console.log(current);


            switch (true) {
                case current == 0:
                    return $(".owl-pagination").html(`<span>${addZero(initItems)}</span> / ${addZero(itemsSize)}`);

                case current > itemsCount:
                    current = itemsCount - (current % itemsCount);
                    return $(".owl-pagination").html(`<span>${addZero(initItems)}</span> / ${addZero(itemsSize)}`);

                default:
                    return $(".owl-pagination").html(`<span>${addZero(current)}</span> / ${addZero(itemsCount)}`);
            }

        }
    }

    homeBillboard() {
       

        if ($(".owl-carousel--billboard-item").length) {
            $(".owl-carousel--billboard-item").owlCarousel({
                margin: 0,
                rewind: true,
                loop: false,
                nav: false,
                dots: false,
                mouseDrag: false,
                touchDrag: true,
                autoplay: true,
                autoplayHoverPause: false,
                autoplayTimeout: 5000,
                smartSpeed: 1000,
                responsiveClass: true,

                responsive: {
                    0: {
                        items: 1,
                    },
                    320: {
                        items: 1,
                    },
                    767: {
                        items: 3,
                    },
                    991: {
                        items: 5,
                    },
                },
            });
        }
    }

    matchCarousel($element1, $element2) {
        var $lineSlide = $($element1);
        var $detailSlide = $($element2);
        var $element1 = $element1;
        var $element2 = $element2;
        $lineSlide.on("initialized.owl.carousel", function (event) {});
        $(".owl-next").click(function () {
            $detailSlide.trigger("next.owl.carousel", [300]);
        });

        $(".owl-prev").click(function () {
            $detailSlide.trigger("prev.owl.carousel", [300]);
        });

        $($element1 + " .item").on("click", function () {
            var slideItem = $(this).data("item");
            var $element1Slide = $(
                $element1 + ' .item[data-item="' + slideItem + '"]'
            );
            var slideIndex = $(
                $element2 + ' .item[data-item="' + slideItem + '"]'
            )
                .parent()
                .index();

            $detailSlide.trigger("to.owl.carousel", slideIndex);
            $(".item").removeClass("center");
            $element1Slide.addClass("center");
        });

        $($element1 + " .item").on("translate.owl.carousel", function () {
            var slideItem = $(this).data("item");
            var slideIndex = $(
                $element1 + ' .item[data-item="' + slideItem + '"]'
            )
                .parent()
                .index();
            $detailSlide.trigger("to.owl.carousel", slideIndex);
        });
        $detailSlide.on("changed.owl.carousel", function (e) {
            var currItem = e.item.index;
            var lineData = $(e.target)
                .find(".owl-item .item")
                .eq(currItem)
                .attr("data-item");
            var $element1Slide = $(
                $element1 + ' .item[data-item="' + lineData + '"]'
            );
            $(".item").removeClass("center");
            $element1Slide.addClass("center");
        });

        $detailSlide.on("changed.owl.carousel", function (e) {
            let flag = false;
            if (!flag) {
                flag = true;
                $lineSlide
                    .find(".owl-item")
                    .removeClass("current")
                    .eq(e.item.index)
                    .addClass("current");

                //
                $lineSlide
                    .find(".owl-item .item")
                    .removeClass("is-current")
                    .eq(e.item.index)
                    .addClass("is-current");

                if (
                    $lineSlide
                        .find(".owl-item")
                        .eq(e.item.index)
                        .hasClass("active")
                ) {
                } else {
                    $lineSlide.trigger("to.owl.carousel", [
                        e.item.index,
                        300,
                        true,
                    ]);
                }
                flag = false;
            }
        });

        $detailSlide.on("changed.owl.carousel", function (event) {
            var items = event.item.count; // Number of items
            var item = event.item.index; // Position of the current item
            // Provided by the navigation plugin

            if (item == 0) {
                // first
                $(".owl-prev").addClass("disabled");
            } else if (item == items - 1) {
                //last
                $(".owl-prev").removeClass("disabled");
                $(".owl-next").addClass("disabled");
            } else {
                $(".owl-prev").removeClass("disabled");
                $(".owl-next").removeClass("disabled");
            }
        });
    }

    homeNews() {
        if ($(".owl-carousel--news-set").length) {
            $(".owl-carousel--news-set").owlCarousel({
                margin: 0,
                rewind: true,
                loop: false,
                slideBy: 'page',
                nav: true,
                navText: [
                    "<i class='icon-arrow-left'></i>",
                    "<i class='icon-arrow-right'></i>",
                ],
                dots: true,
                dotsContainer: ".owl-counter--news-set",
                mouseDrag: true,
                touchDrag: true,
                autoplay: false,
                autoplayHoverPause: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    320: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    991: {
                        items: 3
                    },
                    1024: {
                        items: 3
                        
                    },
                },
            });
        }
        if ($(".owl-carousel--news-press").length) {
            $(".owl-carousel--news-press").owlCarousel({
                margin: 0,
                rewind: true,
                loop: false,
                slideBy: 'page',
                nav: true,
                navText: [
                    "<i class='icon-arrow-left'></i>",
                    "<i class='icon-arrow-right'></i>",
                ],
                dots: true,
                dotsContainer: ".owl-counter--news-press",
                mouseDrag: true,
                touchDrag: true,
                autoplay: false,
                autoplayHoverPause: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    320: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    991: {
                        items: 3
                    },
                    1024: {
                        items: 3
                        
                    },
                },
            });
        }
        if ($(".owl-carousel--news-clippings").length) {
            $(".owl-carousel--news-clippings").owlCarousel({
                margin: 0,
                rewind: true,
                loop: false,
                slideBy: 'page',
                nav: true,
                navText: [
                    "<i class='icon-arrow-left'></i>",
                    "<i class='icon-arrow-right'></i>",
                ],
                dots: true,
                dotsContainer: ".owl-counter--news-clippings",
                mouseDrag: true,
                touchDrag: true,
                autoplay: false,
                autoplayHoverPause: false,
                responsiveClass: true,
                responsive: {
                    0: {
                        items: 1
                    },
                    320: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    991: {
                        items: 3
                    },
                    1024: {
                        items: 3
                        
                    },
                },
            });
        }
    }

    assetInfo() {
        if($('.asset-one').length) {
            $('.asset-one').owlCarousel({
                loop:false,
                margin:10,
                nav:true,
                responsive:{
                    0:{
                        items:1
                    }
                }
            })
        }
        
    }

    homeProject() {
        /**
         * Plugin for linking multiple owl instances
         * @version 1.0.0
         * @author David Deutsch
         * @license The MIT License (MIT)
         */
        (function ($, window, document, undefined) {
            /**
             * Creates the Linked plugin.
             * @class The Linked Plugin
             * @param {Owl} carousel - The Owl Carousel
             */
            var Linked = function (carousel) {
                /**
                 * Reference to the core.
                 * @protected
                 * @type {Owl}
                 */
                this._core = carousel;

                /**
                 * All event handlers.
                 * @protected
                 * @type {Object}
                 */
                this._handlers = {
                    "dragged.owl.carousel changed.owl.carousel": $.proxy(
                        function (e) {
                            if (e.namespace && this._core.settings.linked) {
                                this.update(e);
                            }
                        },
                        this
                    ),
                    "linked.to.owl.carousel": $.proxy(function (
                        e,
                        index,
                        speed,
                        standard,
                        propagate
                    ) {
                        if (e.namespace && this._core.settings.linked) {
                            this.toSlide(index, speed, propagate);
                        }
                    },
                    this),
                };

                // register event handlers
                this._core.$element.on(this._handlers);

                // set default options
                this._core.options = $.extend(
                    {},
                    Linked.Defaults,
                    this._core.options
                );
            };

            /**
             * Default options.
             * @public
             */
            Linked.Defaults = {
                linked: false,
            };

            /**
             * Updated linked instances
             */
            Linked.prototype.update = function (e) {
                this.toSlide(e.relatedTarget.relative(e.item.index));
            };

            /**
             * Carry out the to.owl.carousel proxy function
             * @param {int} index
             * @param {int} speed
             * @param {bool} propagate
             */
            Linked.prototype.toSlide = function (index, speed, propagate) {
                var id = this._core.$element.attr("id"),
                    linked =
                        typeof this._core.settings.linked === "string"
                            ? this._core.settings.linked.split(",")
                            : this._core.settings.linked;

                if (typeof propagate == "undefined") {
                    propagate = true;
                }

                index = index || 0;

                if (propagate) {
                    $.each(linked, function (i, el) {
                        $(el).trigger("linked.to.owl.carousel", [
                            index,
                            300,
                            true,
                            false,
                        ]);
                    });
                } else {
                    this._core.$element.trigger("to.owl.carousel", [
                        index,
                        300,
                        true,
                    ]);

                    if (this._core.settings.current) {
                        this._core._plugins.current.switchTo(index);
                    }
                }
            };

            /**
             * Destroys the plugin.
             * @protected
             */
            Linked.prototype.destroy = function () {
                var handler, property;

                for (handler in this._handlers) {
                    this.$element.off(handler, this._handlers[handler]);
                }
                for (property in Object.getOwnPropertyNames(this)) {
                    typeof this[property] != "function" &&
                        (this[property] = null);
                }
            };

            $.fn.owlCarousel.Constructor.Plugins.linked = Linked;
        })(window.Zepto || window.jQuery, window, document);

        $(".owl-carousel--projects-highlight").owlCarousel({
            items: 1,
            margin: 0,
            dots: true,
            dotsContainer: ".owl-counter--projects",
            nav: true,
            navText: [
                "<i class='icon-arrow-left'></i>",
                "<i class='icon-arrow-right'></i>",
            ],
            navContainer: ".owl-nav-projects",
            rewind: true,
            mouseDrag: false,
            touchDrag: false,
            autoplay: true,
            autoplayTimeout: 5000,
            smartSpeed: 1000,
            autoplayHoverPause: false,
            linked: ".owl-carousel--projects-highlight-detail",
        });
        var syncToFirst = $(".owl-carousel--projects-highlight-detail");
        $(syncToFirst)
            .owlCarousel({
                nav: false,
                rewind: true,
                items: 1,
                margin: 0,
                dots: false,
                mouseDrag: false,
                touchDrag: false,
                autoplay: true,
                autoplayTimeout: 5000,
                animateIn: "fadeIn",
                animateOut: "fadeOut",
                autoplayHoverPause: false,
                linked: syncToFirst.prev(),
            })
            .on("initialized.owl.carousel linked.to.owl.carousel", function () {
                syncToFirst.find(".owl-item.current").removeClass("current");
                var current = syncToFirst.find(".owl-item.active.center").length
                    ? syncToFirst.find(".owl-item.active.center")
                    : syncToFirst.find(".owl-item.active").eq(0);
                current.addClass("current");

                
                
            });

            

            

        //
    }
}

export default Owl;
